module.exports = __webpack_public_path__ + "img/elem_earth.52cd0740.svg";